export enum PeerEventsEnum {
    NEGOTIATION_NEEDED = 'negotiationneeded',
    TRACK = 'track'
}